module.exports = __webpack_public_path__ + "static/media/actu.85cc2e2b.jpg";